// FileUpload.tsx
import React from 'react';
import { Typography, Button } from '@mui/material';
import CloudUploadIcon from '@mui/icons-material/CloudUploadSharp';
import { STATUS } from '../../utils/status';

interface FileUploadProps {
  title?: string;
  subtext?: string;
  accept?: string;
  onFileChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  buttonLabel?: string;
  uploadStatus?: string;
  file?: File | null;
}

const FileUpload: React.FC<FileUploadProps> = ({
  title = 'Upload Media:',
  subtext = 'Only .csv, .tsv, .xls, .xlsx, .xml are accepted',
  accept = '.csv,.tsv,.xls,.xlsx,.xml',
  onFileChange,
  buttonLabel = 'Upload files',
  uploadStatus,
  file
}) => {
  return (
    <div>
      <Typography sx={{
        fontFamily: 'Montserrat',
        fontSize: '18px',
        fontWeight: 600,
        lineHeight: '24px',
        letterSpacing: '0px',
        textAlign: 'left',
        color: '#10383D',
      }}>
        {title}
        <Button
        component="label"
        variant="contained"
        startIcon={<CloudUploadIcon />}
        sx={{marginLeft: 2}}
      >
        {buttonLabel}
        <input
          type="file"
          accept={accept}
          onChange={onFileChange}
          hidden
        />
      </Button><br />
      </Typography>
      <Typography sx={{
        fontFamily: 'Montserrat',
        fontSize: '12px',
        fontWeight: 400,
        lineHeight: '2px',
        letterSpacing: '0px',
        textAlign: 'left',
        color: '#10383D'
      }}>
        {subtext}
      </Typography>
      
      {uploadStatus === STATUS.PENDING && <Typography variant="body2" mt={2}>Uploading File...</Typography>}
      {uploadStatus === STATUS.SUCESS && file && (
        <Typography sx={{ fontFamily: 'Montserrat', fontSize: '14px', color: '#10383D', mt: 1 }}>
          Uploaded file: <strong>{file.name}</strong>
        </Typography>
      )}
      {uploadStatus === STATUS.FAILED && file && (
        <Typography sx={{ fontFamily: 'Montserrat', fontSize: '14px', color: 'red', mt: 1 }}>
          Failed to upload File
        </Typography>
      )}
    </div>
  );
};

export default FileUpload;
